// extracted by mini-css-extract-plugin
export default {"ip_form":"InputForm_ip_form__UyaBP","bttn_input_container":"InputForm_bttn_input_container__iGBlX","ip_input":"InputForm_ip_input__QQbI8","form_bttn":"InputForm_form_bttn__9DLNh"};